import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    paddingLeft: theme.spacing(2)
  },
  container: {
    display: 'inline-flex',
    marginRight: theme.spacing(2)
  },
  bannerText: {
    fontWeight: theme.typography.fontWeightMedium
  },
  delaStarIcon: {
    margin: theme.spacing(0, 0.5),
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(1.5)
  },
  link: {
    textDecoration: 'none'
  }
}));

export const useStickyHeaderStyles = makeStyles(theme => ({
  root: {
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1)
  }
}));

export default useStyles;
